import React from "react";
export const DataNotFound = () => {
  const notfoundCss = `.accordion {
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: var(--i2c-spacing-2-5);
  }
  
  .accordion-header {
    background-color: #f1f1f1;
    padding: var(--i2c-spacing-2-5);
    cursor: pointer;
    border-bottom: 1px solid #ccc;
  }
  
  .accordion-header:hover {
    background-color: #e0e0e0;
  }
  
  .accordion-body {
    display: none;
    padding: var(--i2c-spacing-2-5);
  }
  
  .accordion-body.show {
    display: block;
  }`;

  return (
    <>
      <style>{notfoundCss}</style>
      <div className="accordion">
        <div className="accordion-header">Data not found</div>
        <div className="accordion-body">
          <p>Data you are looking for is not available.</p>
        </div>
      </div>
    </>
  );
};
